module.exports = __webpack_public_path__ + "static/media/forgeticon1.0d42ccb2.png";